import { render, staticRenderFns } from "./DeviceTemp.vue?vue&type=template&id=1878fc39"
import script from "./DeviceTemp.vue?vue&type=script&lang=js"
export * from "./DeviceTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports